import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import queryString from "query-string";
import { fetchMyOrderTimeline } from "../modules/Order/_redux/order/orderAction";
import { CircularProgress } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const AddendumOrder = () => {
  const { search } = useLocation();
  const query = queryString.parse(search);
  const dispatch = useDispatch();

  const { timeline } = useSelector(
    (state) => ({
      timeline: state.order.timeline,
    }),
    shallowEqual
  );

  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    if (query?.order_id) {
      dispatch(fetchMyOrderTimeline(query.order_id));
    }
  }, [query?.order_id, dispatch]);

  if (timeline.length == 0)
    return (
      <div className="text-center py-5">
        <CircularProgress style={{ color: "#fe6601" }} />
        <div style={{ color: "#fe6601", marginTop: 10 }}>Loading Timeline...</div>
      </div>
    );

  if (!timeline)
    return <div className="alert alert-warning mt-4">No timeline found.</div>;

  const logs = Object.values(timeline);

  return (
    <div className="container py-4">
      <h4 className="font-weight-bold mb-4" style={{ color: "#fe6601" }}>
        Order Activity Timeline
      </h4>

      {logs.map((log, index) => {
        let props = log?.properties ?? {};
        if (typeof props === "string") {
          try {
            props = JSON.parse(props);
          } catch {
            props = {};
          }
        }

        const hasDetails =
          props.before?.length > 0 ||
          props.after?.length > 0 ||
          props.changes?.length > 0;

        const open = expandedRow === index;

        return (
          <div
            key={index}
            className="card mb-3 shadow-sm"
            style={{
              borderLeft: "4px solid #fe6601",
              cursor: hasDetails ? "pointer" : "default",
              transition: "0.2s",
            }}
            onClick={() => hasDetails && setExpandedRow(open ? null : index)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow =
                "0 0 10px rgba(254,102,1,0.35)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "0 0 4px rgba(0,0,0,0.15)")
            }
          >
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <strong style={{ color: "#fe6601" }}>
                  {log.description || "Activity"}
                </strong>
                  
                <span
                  style={{
                    padding: "3px 10px",
                    background: "rgba(254,102,1,0.10)",
                    border: "1px solid #fe6601",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#fe6601",
                  }}
                >
                  By: {log?.causer?.first_name || "System"}
                </span>
              </div>

              {/* BUTTON (Clean) */}
              {hasDetails && (
                <button
                  className="btn btn-sm btn-outline-warning mt-3 d-flex align-items-center"
                  style={{
                    fontWeight: 500,
                    borderRadius: 4,
                    gap: 4,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpandedRow(open ? null : index);
                  }}
                >
                  {open ? (
                    <>
                      Hide Details <KeyboardArrowUpIcon fontSize="small" />
                    </>
                  ) : (
                    <>
                      View Details <KeyboardArrowDownIcon fontSize="small" />
                    </>
                  )}
                </button>
              )}

              {/* DETAILS */}
              {open && hasDetails && (
                <div className="mt-3">
                  {/* BEFORE */}
                  {props.before?.length > 0 && (
                    <>
                      <h6 className="mt-3 text-primary">Before Changes</h6>
                      <table className="table table-bordered table-sm">
                        <thead className="thead-light">
                          <tr>
                            {Object.keys(props.before[0]).map((k) => (
                              <th key={k}>{k}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {props.before.map((row, i) => (
                            <tr key={i}>
                              {Object.values(row).map((v, j) => (
                                <td key={j}>{v || "-"}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}

                  {/* AFTER */}
                  {props.after?.length > 0 && (
                    <>
                      <h6 className="mt-3 text-success">After Changes</h6>
                      <table className="table table-bordered table-sm">
                        <thead className="thead-light">
                          <tr>
                            {Object.keys(props.after[0]).map((k) => (
                              <th key={k}>{k}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {props.after.map((row, i) => (
                            <tr key={i}>
                              {Object.values(row).map((v, j) => (
                                <td key={j}>{v || "-"}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}

                  {/* CHANGE SUMMARY */}
                  {props.changes?.length > 0 && (
                    <div className="alert alert-info mt-3">
                      <strong>Change Summary:</strong>
                      <ul className="mt-2">
                        {props.changes.map((c, i) => (
                          <li key={i}>
                            {c.label}: <b>{c.old}</b> → <b>{c.new}</b>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
                    style={{
                      fontSize: "11.5px",
                      color: "#fe6601",
                      background: "rgba(254,102,1,0.08)",
                      padding: "3px 8px",
                      borderRadius: "4px",
                      display: "inline-block",
                    }}
                  >
                    {log?.created_at
                      ? new Date(log.created_at).toLocaleString()
                      : "--"}
                  </div>
          </div>
        );
      })}
    </div>
  );
};

export default AddendumOrder;
